/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

//import axios from 'axios';
import $ from 'jquery'
import * as bootstrap from 'bootstrap';
import swal from 'sweetalert2';
import select2 from 'select2';
import persianDate from 'persian-date/dist/persian-date.min';
import InputMask from 'inputmask';
import Colormask from "inputmask/lib/extensions/colormask.js";
import hightchart from 'highcharts'
import {gantt} from "@yahmat/dhtmlxgantt";
import html2canvas from "html2canvas";
import * as jsPDF from "jspdf";

select2();

window.bootstrap = bootstrap;
window.jQuery = window.$ = $;
window.Inputmask = InputMask;

//window.axios = axios;
window.Swal = swal;
window.persianDate = persianDate;
window.Highcharts = hightchart;

gantt.i18n.setLocale("fa");
gantt.config.jalali = true;

window.Gantt = gantt;

window.html2canvas = html2canvas;
window.jspdf = jsPDF;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
